import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { bindActionCreators } from 'redux'
import { Game } from '../../../../Core'

import * as selectors from '../endgame.selectors'

import * as rankingActions from '../../../Ranking/ranking.actions'

import FederationFlag from '../../../Components/FederationFlag'

const NO_FEDERATION = { name: '', coins: 0, settlers: 0 }

class FederationsPodium extends React.Component {
  selectFederation(federation) {
    const { selectFederation, addScreen } = this.props

    selectFederation(federation)
    addScreen('federation_ranking')
  }

  renderFederation(federationPodium, position) {
    const { report } = this.props
    const federation = federationPodium ? federationPodium : NO_FEDERATION
    const federationAnswers =
      federation.name && report.federationCorrectAnswers[federation.name]
        ? report.federationCorrectAnswers[federation.name]
        : 0
    let fixedPoints =
      isNaN(federation.points) || federation.points == undefined ? 0 : federation.points.toFixed(2)
    let fixedCoins =
      isNaN(federation.coins) || federation.coins == undefined ? 0 : federation.coins.toFixed(2)
    return (
      <div
        onClick={() => (federation.id ? this.selectFederation(federation) : null)}
        className="endgame--position"
      >
        <FederationFlag flag={federation.flag} />
        <ul className="endgame--info">
          <li>
            <span className="num--position">{position}º</span>
          </li>
          <li>
            <div className="text">{federation.name}</div>
          </li>
        </ul>
        <ul className="endgame--info__results">
          <li>
            <span className="icon-colonos"></span>
            <span>{fixedPoints}</span>
          </li>
          <li>
            <span className="icon-coin violet"></span>
            <span className="violet">{fixedCoins}</span>
          </li>
          <li>
            <span className="icon-doing darkgreen"></span>
            <span className="darkgreen">{federationAnswers.toFixed(1)}%</span>
          </li>
        </ul>
      </div>
    )
  }

  render() {
    const { report } = this.props
    if (!report.federationsPodium) {
      return null
    }

    return (
      <div className="endgame--layer">
        {report.federationsPodium.map((federation, index) =>
          this.renderFederation(federation, index + 1)
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    report: selectors.report(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
    selectFederation: bindActionCreators(rankingActions.selectFederation, dispatch),
  }
}

FederationsPodium.propTypes = {
  addScreen: PropTypes.function,
  report: PropTypes.object,
  selectFederation: PropTypes.function,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(FederationsPodium))
